import {DashboardNavigation} from './screensNavigation/Dashboard';
import {createBrowserRouter} from 'react-router-dom';
import {MainHome} from '../screensComponents/HomeScreen/MainHome';
import {ErrorPage} from '../components/common/ErrorPage';
import {IndexNavigation} from './screensNavigation/Index/index';
import React from 'react';
import {PublicRoute} from './PublicRoute';
import {LoginNavigation} from './screensNavigation/Login';
import {DashboardIndexNavigation} from './screensNavigation/DashboardIndex';
import {ROUTE_BASE_NAME} from './RoutePathConstant';
import ExperimentsNavigation from '@app/navigations/screensNavigation/Experiments/ExperimentsNavigation';
import {AppConfig} from '@app/config';
import {ProfileNavigation} from '@app/navigations/screensNavigation/Profile';
import {TenantNavigation} from '@app/navigations/screensNavigation/Tenant';
import {PatientNavigation} from '@app/navigations/screensNavigation/Patients';
import {CallNavigation} from '@app/navigations/screensNavigation/Calls';
import {AnalyticsNavigation} from '@app/navigations/screensNavigation/Analytics';

const AuthRoute = [
  ...DashboardNavigation,
  ...ExperimentsNavigation,
  ...ProfileNavigation,
  ...TenantNavigation,
  ...PatientNavigation,
  ...CallNavigation,
  ...AnalyticsNavigation,
];

let ExperimentsRoute: any = [];

if (AppConfig.APP_PROFILE.toLowerCase() === 'DEV'.toLowerCase()) {
  // add experiments in dev env
  ExperimentsRoute = [...ExperimentsNavigation];
}

export const AppRouter = createBrowserRouter([
  IndexNavigation,
  ...LoginNavigation,
  {
    path: '',
    element: <MainHome />,
    errorElement: <ErrorPage />,
    children: [
      DashboardIndexNavigation,
      ...AuthRoute,
      ...ExperimentsRoute,
      ...PublicRoute,
    ],
  },
], {
  basename: ROUTE_BASE_NAME,
});
